export default "__VITE_ASSET__BwmSr8sY__"